import React, { forwardRef } from "react";
import { Paper } from "@mui/material";
import { SxProps } from "@mui/material";

type Props = {
  children: React.ReactNode;
  sx?: SxProps;
}

const ContainerPaper = forwardRef<HTMLDivElement, Props>(({children, sx, ...rest}, ref) => {
  return (
    <Paper
      sx={{...{
        p: 2,
        m: 3,
        display: "flex",
        flexDirection: "column",
        outline: "none"
      }, ...sx}}
      ref={ref}
      {...rest}
    >
      {children}
    </Paper>
  )
});
export default ContainerPaper;
